import React, { useEffect, Fragment } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";

import Container from "../components/container";
import Footer from "../components/footer";
import Header from "../components/header";
import UploadFormContainer from "../components/upload-form/container";
import { login } from "../store/action";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 70px;
`;

const Subline = styled.span`
  font-size: 16px;
  color: ${(props) => props.theme.palette.primary};
  font-family: "Muli", sans-serif;
  margin-top: 50px;
  padding: 30px;
  text-align: center;
  max-width: 480px;
`;

const FileFormats = styled.div`
  font-size: 12px;
  color: ${(props) => props.theme.palette.primary};
  font-family: "Muli", sans-serif;
  margin-top: 10px;
`;

const StartRoute = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(login());
  }, [dispatch]);

  return (
    <Fragment>
      <Header />
      <Container>
        <Subline>
          Here, we give you the opportunity to test our AI-powered extraction
          module in real-time. This demo is limited to German invoices, for
          further use cases do not hesitate to request a quote.
        </Subline>

        <Wrapper>
          <UploadFormContainer buttonLabel="Upload file" />
          <FileFormats>PNG, TIFF, PDF, JPG</FileFormats>
        </Wrapper>
      </Container>
      <Footer />
    </Fragment>
  );
};

export default StartRoute;
